import ToastPresentationPropsDefault from "@insite/mobius/Toast/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...ToastPresentationPropsDefault,
        closeButtonProps: {
            ...ToastPresentationPropsDefault?.closeButtonProps,
            shape: "rectangle",
            color: null,
            size: 24,
            buttonType: null,
            css: css`
                position: absolute;
                top: 0;
                right: 0;
                width: 36px;
                height: 36px;
                padding: 0;
                border: 0;
                background-color: transparent;
                transition: none;

                &:focus {
                    outline-offset: -${props => props.theme?.focus?.width};
                }
            `,
        },
        closeButtonIconProps: {
            ...ToastPresentationPropsDefault?.closeButtonIconProps,
            color: "text",
        },
    },
};
